/**
 * Malayalam (മലയാളം) translations
 */
import { TranslationStrings } from '../types';

export const ml: TranslationStrings = {  common: {
    loading: 'ലോഡ് ചെയ്യുന്നു...',
    error: 'ഒരു പിശക് സംഭവിച്ചു',
    retry: 'വീണ്ടും ശ്രമിക്കുക',
    cancel: 'റദ്ദാക്കുക',
    confirm: 'സ്ഥിരീകരിക്കുക',
    back: 'മടങ്ങുക',
    next: 'അടുത്തത്',
    submit: 'സമർപ്പിക്കുക',
    done: 'കഴിഞ്ഞു',
    close: 'അടയ്ക്കുക',
    yes: 'അതെ',
    no: 'ഇല്ല',
    required: 'ആവശ്യമാണ്',
    optional: 'ഓപ്ഷണൽ',
  },
  consent: {
    secureConsent: 'സുരക്ഷിത സമ്മതം',
    yourConsentRequired: 'നിങ്ങളുടെ സമ്മതം ആവശ്യമാണ്',
    consentingAs: 'ആയി സമ്മതം നൽകുന്നു',
    requestingOrg: 'അഭ്യർത്ഥിക്കുന്ന സ്ഥാപനം',
    dataBeingCollected: 'ശേഖരിക്കുന്ന ഡാറ്റ',
    purposeOfProcessing: 'പ്രോസസ്സിംഗിന്റെ ഉദ്ദേശ്യം',
    whatYouWillDo: 'നിങ്ങൾ എന്ത് ചെയ്യും',
    reviewDocuments: 'രേഖകൾ അവലോകനം ചെയ്യുക',
    provideConsent: 'സമ്മതം നൽകുക',
    documentsToRead: 'വായിക്കാനുള്ള രേഖകൾ',
    estimatedTime: 'കണക്കാക്കിയ സമയം',
    minutes: 'മിനിറ്റ്',
    startReview: 'അവലോകനം ആരംഭിക്കുക',
    yourRights: 'DPDP ആക്ട് 2023 പ്രകാരം നിങ്ങളുടെ അവകാശങ്ങൾ',
    rightToAccess: 'നിങ്ങളുടെ ഡാറ്റ ആക്സസ് ചെയ്യാനുള്ള അവകാശം',
    rightToCorrect: 'നിങ്ങളുടെ ഡാറ്റ തിരുത്താനുള്ള അവകാശം',
    rightToWithdraw: 'സമ്മതം പിൻവലിക്കാനുള്ള അവകാശം',
    rightToGrievance: 'പരാതി നൽകാനുള്ള അവകാശം',
    stepOf: 'ഘട്ടം {current} / {total}',
    pleaseReadCarefully: 'സമ്മതം നൽകുന്നതിന് മുമ്പ് ഓരോ രേഖയും ശ്രദ്ധാപൂർവ്വം വായിക്കുക.',
    documentsReviewed: 'അവലോകനം ചെയ്ത രേഖകൾ',
    remaining: 'ബാക്കി',
    allDocumentsReviewed: 'എല്ലാ രേഖകളും അവലോകനം ചെയ്തു!',
    clickToRead: 'വായിക്കാൻ ഓരോ രേഖയിലും ക്ലിക്ക് ചെയ്യുക',
    proceedToConsent: 'നിങ്ങൾക്ക് സമ്മതം നൽകാൻ മുന്നോട്ട് പോകാം',
    markAsRead: 'വായിച്ചതായി അടയാളപ്പെടുത്തുക',
    continueReading: 'വായന തുടരുക',
    confirmConsent: 'നിങ്ങളുടെ സമ്മതം സ്ഥിരീകരിക്കുക',
    selectMethod: 'പരിശോധന രീതി തിരഞ്ഞെടുക്കുക',
    iAgreeToTerms: 'എല്ലാ നിബന്ധനകളും നയങ്ങളും സമ്മത കരാറുകളും ഞാൻ അംഗീകരിക്കുന്നു',
    readAllDocuments: 'എന്റെ സമ്മതം സ്വമേധയാ ഉള്ളതാണെന്നും എപ്പോൾ വേണമെങ്കിലും പിൻവലിക്കാമെന്നും ഞാൻ മനസ്സിലാക്കുന്നു',
    submitConsent: 'സമ്മതം സമർപ്പിക്കുക',
    submitting: 'സമർപ്പിക്കുന്നു...',
    digitalSignature: 'ഡിജിറ്റൽ ഒപ്പ്',
    smsVerification: 'SMS പരിശോധന',
    emailVerification: 'ഇമെയിൽ പരിശോധന',
    videoRecording: 'വീഡിയോ റെക്കോർഡിംഗ്',
    audioRecording: 'ഓഡിയോ റെക്കോർഡിംഗ്',
    checkboxConfirmation: 'ചെക്ക്ബോക്സ് സ്ഥിരീകരണം',
    drawSignature: 'നിങ്ങളുടെ ഒപ്പ് വരയ്ക്കുക',
    verifyViaSms: 'SMS കോഡ് വഴി പരിശോധിക്കുക',
    verifyViaEmail: 'ഇമെയിൽ കോഡ് വഴി പരിശോധിക്കുക',
    recordVideoConsent: 'വീഡിയോ സമ്മതം റെക്കോർഡ് ചെയ്യുക',
    recordAudioConsent: 'ഓഡിയോ സമ്മതം റെക്കോർഡ് ചെയ്യുക',
    confirmByChecking: 'ചെക്ക് ചെയ്ത് സ്ഥിരീകരിക്കുക',
    enterOtp: 'OTP നൽകുക',
    otpSentTo: 'OTP അയച്ചു',
    resendOtp: 'OTP വീണ്ടും അയയ്ക്കുക',
    verifyOtp: 'OTP പരിശോധിക്കുക',
    otpVerified: 'OTP പരിശോധിച്ചു',
    invalidOtp: 'അസാധുവായ OTP',
    startRecording: 'റെക്കോർഡിംഗ് ആരംഭിക്കുക',
    stopRecording: 'റെക്കോർഡിംഗ് നിർത്തുക',
    retake: 'വീണ്ടും എടുക്കുക',
    recordingComplete: 'റെക്കോർഡിംഗ് പൂർത്തിയായി',
    consentSubmitted: 'സമ്മതം വിജയകരമായി സമർപ്പിച്ചു',
    thankYou: 'സമ്മതം നൽകിയതിന് നന്ദി',
    confirmationSent: 'നിങ്ങളുടെ ഇമെയിലിലേക്ക് സ്ഥിരീകരണം അയച്ചു',
    referenceNumber: 'റഫറൻസ് നമ്പർ',
    errorSubmitting: 'സമ്മതം സമർപ്പിക്കുന്നതിൽ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.',
    pleaseReadDocs: 'ആദ്യം എല്ലാ രേഖകളും വായിക്കുക',
    pleaseProvideEvidence: 'സമ്മത തെളിവ് നൽകുക',
  },
  documents: {
    privacyPolicy: 'സ്വകാര്യതാ നയം',
    termsOfService: 'സേവന നിബന്ധനകൾ',
    consentAgreement: 'സമ്മതം',
    dataSharingAgreement: 'ഡാറ്റ പങ്കിടൽ കരാർ',
    cookiePolicy: 'കുക്കി നയം',
    retentionPolicy: 'ഡാറ്റ സൂക്ഷിപ്പ് നയം',
    gdprNotice: 'GDPR അറിയിപ്പ്',
    hipaaAuthorization: 'HIPAA അംഗീകാരം',
    ccpaDisclosure: 'CCPA വെളിപ്പെടുത്തൽ',
    aadhaarAuthorization: 'ആധാർ അംഗീകാരം',
    customDocument: 'ഇഷ്ടാനുസൃത രേഖ',
  },
  dataCategories: {
    personalInfo: 'വ്യക്തിഗത വിവരങ്ങൾ',
    contactDetails: 'ബന്ധപ്പെടാനുള്ള വിശദാംശങ്ങൾ',
    financialInfo: 'സാമ്പത്തിക വിവരങ്ങൾ',
    healthData: 'ആരോഗ്യ, വൈദ്യ ഡാറ്റ',
    biometricData: 'ബയോമെട്രിക് ഡാറ്റ',
    locationData: 'ലൊക്കേഷൻ ഡാറ്റ',
    behavioralData: 'പെരുമാറ്റ ഡാറ്റ',
    communicationData: 'ആശയവിനിമയ ഡാറ്റ',
    employmentInfo: 'തൊഴിൽ വിവരങ്ങൾ',
    educationInfo: 'വിദ്യാഭ്യാസ വിവരങ്ങൾ',
  },
  a11y: {
    mainContent: 'പ്രധാന ഉള്ളടക്കം',
    navigation: 'നാവിഗേഷൻ',
    closeModal: 'മോഡൽ അടയ്ക്കുക',
    expandSection: 'വിഭാഗം വിപുലീകരിക്കുക',
    collapseSection: 'വിഭാഗം ചുരുക്കുക',
    documentRead: 'രേഖ വായിച്ചതായി അടയാളപ്പെടുത്തി',
    documentUnread: 'രേഖ ഇതുവരെ വായിച്ചിട്ടില്ല',
    progressIndicator: 'പുരോഗതി: {current} / {total} രേഖകൾ വായിച്ചു',
    signaturePad: 'ഒപ്പ് മേഖല',
    clearSignature: 'ഒപ്പ് മായ്ക്കുക',
    videoPlayer: 'വീഡിയോ റെക്കോർഡിംഗ് പ്ലേയർ',
    audioPlayer: 'ഓഡിയോ റെക്കോർഡിംഗ് പ്ലേയർ',
    requiredField: 'ഈ ഫീൽഡ് ആവശ്യമാണ്',
    errorMessage: 'പിശക്',
    successMessage: 'വിജയം',
    loadingContent: 'ഉള്ളടക്കം ലോഡ് ചെയ്യുന്നു, കാത്തിരിക്കുക',
    newWindow: 'പുതിയ വിൻഡോയിൽ തുറക്കുന്നു',
  },
  portal: {
    // General
    myConsents: 'എന്റെ സമ്മതങ്ങൾ',
    viewManageConsents: 'നിങ്ങളുടെ സമ്മത രേഖകൾ കാണുകയും കൈകാര്യം ചെയ്യുകയും ചെയ്യുക',
    logout: 'ലോഗൗട്ട്',
    welcomeBack: 'തിരികെ സ്വാഗതം',
    
    // Tenant selector
    organizationNameOrCode: 'സ്ഥാപനത്തിന്റെ പേര് അല്ലെങ്കിൽ കോഡ്',
    orgPlaceholder: 'ഉദാ., globalhealth അല്ലെങ്കിൽ acme-corp',
    orgHint: 'നിങ്ങളുടെ സ്ഥാപനം നൽകിയ പേര് അല്ലെങ്കിൽ കോഡ് നൽകുക',
    findMyOrganization: 'എന്റെ സ്ഥാപനം കണ്ടെത്തുക',
    orgNotFound: 'സ്ഥാപനം കണ്ടെത്തിയില്ല. പേര് പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
    enterOrgName: 'നിങ്ങളുടെ സ്ഥാപനത്തിന്റെ പേര് അല്ലെങ്കിൽ കോഡ് നൽകുക',
    or: 'അല്ലെങ്കിൽ',
    haveDirectLink: 'നിങ്ങളുടെ സ്ഥാപനത്തിൽ നിന്ന് നേരിട്ടുള്ള ലിങ്ക് ഉണ്ടോ?',
    useDirectLink: 'അവർ നൽകിയ ലിങ്ക് ഉപയോഗിക്കുക',
    privacyProtected: 'നിങ്ങളുടെ സ്വകാര്യത നിയമത്താൽ സംരക്ഷിക്കപ്പെട്ടിരിക്കുന്നു',
    
    // Login flow
    phoneOrEmail: 'ഫോൺ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ',
    enterPhoneOrEmailPlaceholder: 'നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഫോൺ അല്ലെങ്കിൽ ഇമെയിൽ നൽകുക',
    otpWillBeSent: 'ഞങ്ങൾ നിങ്ങൾക്ക് ഒരു വൺ-ടൈം പാസ്‌വേഡ് (OTP) അയയ്ക്കും',
    sendOtp: 'OTP അയയ്ക്കുക',
    enterPhoneOrEmail: 'നിങ്ങളുടെ ഫോൺ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ നൽകുക',
    otpSentTo: 'OTP അയച്ചു',
    expiresIn: 'കാലഹരണപ്പെടും',
    enterOtp: 'OTP നൽകുക',
    enterValidOtp: 'സാധുവായ OTP നൽകുക',
    verifyOtp: 'OTP പരിശോധിക്കുക',
    resendOtp: 'OTP വീണ്ടും അയയ്ക്കുക',
    otpVerified: 'OTP പരിശോധിച്ചു',
    oneMoreStep: 'നിങ്ങളുടെ ഐഡന്റിറ്റി പരിശോധിക്കാൻ ഒരു ഘട്ടം കൂടി',
    enterSecurityAnswer: 'നിങ്ങളുടെ ഉത്തരം നൽകുക',
    enterAnswer: 'ഉത്തരം നൽകുക',
    dobFormat: 'ഫോർമാറ്റ്: DDMMYYYY (ഉദാ., 15051990 മെയ് 15, 1990)',
    login: 'ലോഗിൻ',
    startOver: 'വീണ്ടും തുടങ്ങുക',
    needHelp: 'സഹായം വേണോ?',
    privacyNotice: 'നിങ്ങളുടെ ഡാറ്റ ബാധകമായ സ്വകാര്യത നിയമങ്ങൾക്ക് കീഴിൽ സംരക്ഷിക്കപ്പെട്ടിരിക്കുന്നു',
    checkUrlOrContact: 'URL പരിശോധിക്കുക അല്ലെങ്കിൽ നിങ്ങളുടെ സ്ഥാപനവുമായി ബന്ധപ്പെടുക.',
    
    // Consent history
    filterAll: 'എല്ലാം',
    statusActive: 'സജീവം',
    statusWithdrawn: 'പിൻവലിച്ചു',
    statusExpired: 'കാലഹരണപ്പെട്ടു',
    noConsents: 'സമ്മത രേഖകൾ കണ്ടെത്തിയില്ല',
    noConsentsWithFilter: 'ഈ നിലയിൽ സമ്മതങ്ങളില്ല',
    consentedOn: 'സമ്മതിച്ച തീയതി',
    expiresOn: 'കാലഹരണപ്പെടുന്ന തീയതി',
    withdrawnOn: 'പിൻവലിച്ച തീയതി',
    withdrawConsent: 'സമ്മതം പിൻവലിക്കുക',
    withdrawalHistory: 'പിൻവലിക്കൽ ചരിത്രം',
    help: 'സഹായം',
    
    // Withdrawal
    cannotWithdraw: 'ഈ സമ്മതം പിൻവലിക്കാൻ കഴിയില്ല',
    pleaseConfirmWithdrawal: 'പ്രത്യാഘാതങ്ങൾ മനസ്സിലാക്കിയെന്ന് സ്ഥിരീകരിക്കുക',
    importantNotice: 'പ്രധാന അറിയിപ്പ്',
    withdrawalNotice1: 'സ്ഥാപനം പ്രസ്താവിച്ച ആവശ്യങ്ങൾക്കായി നിങ്ങളുടെ ഡാറ്റ പ്രോസസ്സ് ചെയ്യുന്നത് നിർത്തും.',
    withdrawalNotice2: 'നിയമാനുസൃത പാലനത്തിനായി ചില ഡാറ്റ സൂക്ഷിക്കാം.',
    withdrawalNotice3: 'ചില സേവനങ്ങൾ ഉപയോഗിക്കാൻ നിങ്ങൾ വീണ്ടും സമ്മതം നൽകേണ്ടതായി വരാം.',
    withdrawalNotice4: 'ബാധകമായ നിയമങ്ങൾ അനുസരിച്ച് പ്രോസസ്സിംഗ് സമയം 7-30 ദിവസം ആകാം.',
    withdrawalReason: 'പിൻവലിക്കുന്നതിനുള്ള കാരണം',
    withdrawalReasonPlaceholder: 'നിങ്ങൾ എന്തുകൊണ്ട് പിൻവലിക്കാൻ ആഗ്രഹിക്കുന്നു എന്ന് പറയുക (ഓപ്ഷണൽ)',
    withdrawalConfirmation: 'എന്റെ സമ്മതം പിൻവലിക്കുന്നത് ചില സേവനങ്ങൾ ഉപയോഗിക്കാനുള്ള എന്റെ കഴിവിനെ ബാധിക്കാമെന്ന് ഞാൻ മനസ്സിലാക്കുന്നു, ഈ അഭ്യർത്ഥനയുമായി മുന്നോട്ട് പോകാൻ ഞാൻ ആഗ്രഹിക്കുന്നു.',
    submitWithdrawalRequest: 'പിൻവലിക്കൽ അഭ്യർത്ഥന സമർപ്പിക്കുക',
    withdrawalSubmitted: 'പിൻവലിക്കൽ അഭ്യർത്ഥന സമർപ്പിച്ചു',
    withdrawalSubmittedDesc: 'നിങ്ങളുടെ പിൻവലിക്കൽ അഭ്യർത്ഥന സമർപ്പിച്ചു. സ്ഥാപനം പ്രോസസ്സ് ചെയ്തുകഴിഞ്ഞാൽ നിങ്ങളെ അറിയിക്കും.',
    processingTime: 'പ്രോസസ്സിംഗ് സമയം',
    days: 'ദിവസങ്ങൾ',
    backToHistory: 'സമ്മത ചരിത്രത്തിലേക്ക് മടങ്ങുക',
    
    // Withdrawal history
    statusPending: 'തീർപ്പാക്കാത്ത',
    statusApproved: 'അംഗീകരിച്ചു',
    statusRejected: 'നിരസിച്ചു',
    noWithdrawals: 'പിൻവലിക്കൽ അഭ്യർത്ഥനകളില്ല',
    viewConsents: 'നിങ്ങളുടെ സമ്മതങ്ങൾ കാണുക',
    requestedOn: 'അഭ്യർത്ഥിച്ച തീയതി',
    processedOn: 'പ്രോസസ്സ് ചെയ്ത തീയതി',
    processingMessage: 'നിങ്ങളുടെ അഭ്യർത്ഥന പ്രോസസ്സ് ചെയ്യുന്നു. പൂർത്തിയായാൽ നിങ്ങളെ അറിയിക്കും.',
    processingTimeInfo: 'പ്രോസസ്സിംഗ് സമയ വിവരങ്ങൾ',
    
    // Help section
    yourRights: 'നിങ്ങളുടെ സ്വകാര്യത അവകാശങ്ങൾ',
    helpTitle: 'നിങ്ങളുടെ സ്വകാര്യത അവകാശങ്ങൾ മനസ്സിലാക്കുക',
    helpSubtitle: 'സ്വകാര്യത നിയമങ്ങൾക്ക് കീഴിലുള്ള നിങ്ങളുടെ അവകാശങ്ങളും സമ്മതം എങ്ങനെ കൈകാര്യം ചെയ്യാമെന്നും അറിയുക.',
    quickActions: 'വേഗ പ്രവർത്തനങ്ങൾ',
    viewMyConsents: 'എന്റെ സമ്മതങ്ങൾ കാണുക',
    viewWithdrawalRequests: 'പിൻവലിക്കൽ അഭ്യർത്ഥനകൾ കാണുക',
    loginToViewConsents: 'നിങ്ങളുടെ സമ്മതങ്ങൾ കാണാൻ ലോഗിൻ ചെയ്യുക',
    applicableLaws: 'ബാധകമായ സ്വകാര്യത നിയമങ്ങൾ',
    
    // Rights FAQ
    rightAccessQ: 'ആക്സസ് അവകാശം എന്താണ്?',
    rightAccessA: 'നിങ്ങളെക്കുറിച്ച് എന്ത് വ്യക്തിഗത ഡാറ്റ ശേഖരിക്കുന്നു, അത് എങ്ങനെ ഉപയോഗിക്കുന്നു, ആരുമായി പങ്കിടുന്നു എന്ന് അറിയാനുള്ള അവകാശം നിങ്ങൾക്കുണ്ട്.',
    rightCorrectQ: 'തിരുത്തൽ അവകാശം എന്താണ്?',
    rightCorrectA: 'നിങ്ങളുടെ വ്യക്തിഗത ഡാറ്റ തെറ്റോ അപൂർണ്ണമോ ആണെങ്കിൽ, അത് തിരുത്താനോ അപ്ഡേറ്റ് ചെയ്യാനോ അഭ്യർത്ഥിക്കാം.',
    rightWithdrawQ: 'സമ്മതം പിൻവലിക്കാനുള്ള അവകാശം എന്താണ്?',
    rightWithdrawA: 'നിങ്ങൾക്ക് എപ്പോൾ വേണമെങ്കിലും നിങ്ങളുടെ സമ്മതം പിൻവലിക്കാം. പിൻവലിച്ചുകഴിഞ്ഞാൽ, നിങ്ങൾ സമ്മതിച്ച ആവശ്യങ്ങൾക്കായി നിങ്ങളുടെ ഡാറ്റ പ്രോസസ്സ് ചെയ്യുന്നത് സ്ഥാപനം നിർത്തണം.',
    rightEraseQ: 'ഇല്ലാതാക്കൽ അവകാശം എന്താണ്?',
    rightEraseA: '"മറക്കാനുള്ള അവകാശം" എന്നും അറിയപ്പെടുന്ന, നിങ്ങളുടെ വ്യക്തിഗത ഡാറ്റ ഇല്ലാതാക്കാൻ അഭ്യർത്ഥിക്കാം. എന്നിരുന്നാലും, ചില വിവരങ്ങൾ സൂക്ഷിക്കാൻ നിയമപരമായ കാരണങ്ങളുണ്ടാകാം.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'പിൻവലിക്കൽ പ്രക്രിയ',
    withdrawHowQ: 'എന്റെ സമ്മതം എങ്ങനെ പിൻവലിക്കാം?',
    withdrawHowA: 'നിങ്ങളുടെ അക്കൗണ്ടിൽ ലോഗിൻ ചെയ്യുക, സമ്മത ചരിത്രത്തിലേക്ക് പോകുക, സജീവ സമ്മതത്തിൽ "സമ്മതം പിൻവലിക്കുക" ക്ലിക്ക് ചെയ്യുക.',
    withdrawTimeQ: 'പിൻവലിക്കാൻ എത്ര സമയമെടുക്കും?',
    withdrawTimeA: 'ബാധകമായ നിയമങ്ങൾ അനുസരിച്ച് പ്രോസസ്സിംഗ് സമയം: DPDP നിയമം (ഇന്ത്യ) - 7 ദിവസം, GDPR (EU) - 30 ദിവസം, CCPA (കാലിഫോർണിയ) - 45 ദിവസം.',
    withdrawEffectQ: 'സമ്മതം പിൻവലിച്ച ശേഷം എന്ത് സംഭവിക്കും?',
    withdrawEffectA: 'പ്രസ്താവിച്ച ആവശ്യങ്ങൾക്കായി നിങ്ങളുടെ ഡാറ്റ ഉപയോഗിക്കുന്നത് സ്ഥാപനം നിർത്തും. നിയമാനുസൃത പാലനത്തിനായി ചില ഡാറ്റ സൂക്ഷിക്കാം.',
    
    // Security FAQ
    securityFaq: 'അക്കൗണ്ട് സുരക്ഷ',
    loginSecureQ: 'എന്റെ ലോഗിൻ എങ്ങനെ സുരക്ഷിതമാണ്?',
    loginSecureA: 'ഞങ്ങൾ 3-ഘട്ട പരിശോധനാ പ്രക്രിയ ഉപയോഗിക്കുന്നു: രജിസ്റ്റർ ചെയ്ത ഫോൺ/ഇമെയിലിലേക്ക് OTP, പിന്നീട് സുരക്ഷാ ചോദ്യം.',
    dataProtectQ: 'എന്റെ ഡാറ്റ എങ്ങനെ സംരക്ഷിക്കപ്പെടുന്നു?',
    dataProtectA: 'എല്ലാ ഡാറ്റയും ട്രാൻസിറ്റിലും റെസ്റ്റിലും എൻക്രിപ്റ്റ് ചെയ്തിരിക്കുന്നു. DPDP നിയമം, GDPR, മറ്റ് സ്വകാര്യത നിയന്ത്രണങ്ങൾ എന്നിവ പാലിക്കുന്നു.',
    
    // Contact FAQ
    contactFaq: 'ബന്ധപ്പെടൽ & പിന്തുണ',
    grievanceQ: 'പരാതി എങ്ങനെ ഫയൽ ചെയ്യാം?',
    grievanceA: 'സ്ഥാപനത്തിന്റെ ഡാറ്റ പ്രൊട്ടക്ഷൻ ഓഫീസർ (DPO) അല്ലെങ്കിൽ ഗ്രീവൻസ് ഓഫീസറെ ബന്ധപ്പെടാം.',
    regulatorQ: 'റെഗുലേറ്ററി അതോറിറ്റി ആരാണ്?',
    regulatorA: 'ഇന്ത്യയിൽ, ഡാറ്റ പ്രൊട്ടക്ഷൻ ബോർഡ് സ്വകാര്യത പരാതികൾ കൈകാര്യം ചെയ്യുന്നു. EU-ൽ, നിങ്ങളുടെ ദേശീയ ഡാറ്റ പ്രൊട്ടക്ഷൻ അതോറിറ്റിയെ ബന്ധപ്പെടാം.',
  },
}
;
